import { connect } from "react-redux";
import { Dispatch } from "@reduxjs/toolkit";
import Layout from "./";
import {
  setTheme,
  setTimeZone,
  setUserInfo,
  setUserRoles, setWorkingTenant,
} from "@/redux/setting-slice/SettingSlice.ts";
import { TimezoneInfo } from "@/services/entities/SettingEntity.ts";
import { onHandleTokenToGetRoles } from "@/commons/RoleFunction.ts";
import {
  LoginManager,
  LoginManagerImpl,
} from "@/services/login-service/LoginService.ts";
import { ETheme } from "@/DependenciesV9";
import { AuthenticationFunctions } from "@/commons/AuthenticationFunctions.ts";

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  const loginService: LoginManager = new LoginManagerImpl();
  return {
    setTheme: (theme: ETheme) => {
      dispatch(setTheme(theme));
    },
    setUserInfo: async (): Promise<void> => {
      const resp = await loginService.getUserInformation();
      if (!resp.error) {
        dispatch(setUserInfo(resp.data));
      }
    },
    setTimeZone: (timeZone: TimezoneInfo) => {
      dispatch(setTimeZone(timeZone));
    },
    setUserRoles: () => {
      const loginInfo = localStorage.getItem("LOGIN_INFO");
      if (loginInfo) {
        const storage = JSON.parse(loginInfo);
        const RoleData = onHandleTokenToGetRoles(storage.accessToken);
        const tenantId = AuthenticationFunctions.getTokenDataByKey("tenantId")
        dispatch(setWorkingTenant(tenantId));
        dispatch(setUserRoles(RoleData.AccessControls));
      }
    },
  };
};

export default connect(null, mapDispatchToProps)(Layout);
